/*global google*/ //<-- ห้ามลบ
import React, { useEffect, useRef } from "react";

const API_KEY = process.env.REACT_APP_GOOGLE_MAP_KEY;
const DEFAULT_CENTER = { lat: 13.756, lng: 100.501 };
let map, marker, scriptPromise;

// โหลด Google Maps script ครั้งเดียว (โหลดซ้ำทุกครั้งที่เปิด modal จะทำให้แผนที่ error)
const loadGoogleMaps = () => {
  if (window.google && window.google.maps) return Promise.resolve();
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}`;
      script.async = true;
      script.addEventListener("load", resolve);
      script.addEventListener("error", (e) => {
        scriptPromise = null;
        reject(e);
      });
      window.document.body.appendChild(script);
    });
  }
  return scriptPromise;
};

// กัน lat/lng เป็น undefined / null / NaN
const toCenter = (location) => {
  const lat = Number(location && location.lat);
  const lng = Number(location && location.lng);
  if (lat && lng && !isNaN(lat) && !isNaN(lng)) return { lat, lng };
  return DEFAULT_CENTER;
};

function GoogleMap({ mapMode, location, getLocation, locationName, zoom }) {
  const getLocationRef = useRef(getLocation);
  getLocationRef.current = getLocation;

  useEffect(() => {
    loadGoogleMaps()
      .then(() => initMap())
      .catch((e) => console.error("Google Maps load failed", e));
  }, []);

  useEffect(() => {
    setLocation();
  }, [location]);

  const initMap = () => {
    const el = document.getElementById("gmap");
    if (!el) return;
    const center = toCenter(location);

    if (mapMode == "show") {
      map = new google.maps.Map(el, {
        zoom: zoom ? zoom : 12,
        center: center,
      });
      marker = new google.maps.Marker({
        position: center,
        map: map,
        draggable: false,
        title: locationName,
      });
    } else if (mapMode == "addPin") {
      map = new google.maps.Map(el, {
        zoom: zoom ? zoom : 12,
        center: center,
      });
      marker = new google.maps.Marker({
        position: center,
        map: map,
        draggable: true,
        title: locationName,
      });

      google.maps.event.addListener(marker, "dragend", function () {
        if (getLocationRef.current) {
          getLocationRef.current({
            lat: this.getPosition().lat(),
            lng: this.getPosition().lng(),
          });
        }
      });

      map.addListener("click", (e) => {
        if (getLocationRef.current) {
          getLocationRef.current({
            lat: e.latLng.lat(),
            lng: e.latLng.lng(),
          });
        }
        addMarker(e.latLng);
      });
    }
  };

  const addMarker = (location) => {
    if (marker) {
      marker.setPosition(location);
    } else {
      marker = new google.maps.Marker({
        position: location,
        map: map,
      });
    }
  };

  const setLocation = () => {
    if (map && marker) {
      marker.setPosition(toCenter(location));
    }
  };

  return <div id="gmap" className="h-100"></div>;
}

export default GoogleMap;
